import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import {
  List,
  ListHeader,
  ListHeaderItem,
  ListBody,
  ListItem,
  ListItemColumn,
  Avatar,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import enrollmentSummaryShape from 'Workspace/types/cohorts/cohortEnrollment';
import AccountHelper from 'Workspace/helpers/AccountHelper';

import {
  AvatarWrapper,
} from './styles';

import messages from './messages';

const CohortEnrollmentsList = ({ enrollments }) => (
  <List>
    <ListHeader>
      <ListItemColumn>
        <ListHeaderItem>{intl.formatMessage(messages.listColumnHeaderTextName)}</ListHeaderItem>
      </ListItemColumn>
      <ListItemColumn>
        <ListHeaderItem>{intl.formatMessage(messages.listColumnHeaderTextEmail)}</ListHeaderItem>
      </ListItemColumn>
      <ListItemColumn>
        <ListHeaderItem>{intl.formatMessage(messages.listColumnHeaderTextEnrollmentDate)}</ListHeaderItem>
      </ListItemColumn>
      <ListItemColumn>
        <ListHeaderItem>{intl.formatMessage(messages.listColumnHeaderTextEnrollmentType)}</ListHeaderItem>
      </ListItemColumn>
    </ListHeader>
    <ListBody>
      {
        enrollments
          .sort((a, b) => AccountHelper.sortListByFamilyName(a.accountSummary, b.accountSummary))
          .map(({ accountSummary, enrolledAt, enrollmentType }) => (
            <ListItem
              key={`enrollments-item-${accountSummary.accountId}`}
            >
              <ListItemColumn>
                <AvatarWrapper>
                  <Avatar avatar={accountSummary} />
                </AvatarWrapper>
                { AccountHelper.getFullName(accountSummary)}
              </ListItemColumn>
              <ListItemColumn>
                { accountSummary.primaryEmail }
              </ListItemColumn>
              <ListItemColumn>
                <FormattedDate
                  value={new Date(enrolledAt)}
                  year="numeric"
                  month="short"
                />
              </ListItemColumn>
              <ListItemColumn>
                { enrollmentType }
              </ListItemColumn>
            </ListItem>
          ))
      }
    </ListBody>
  </List>
);

CohortEnrollmentsList.propTypes = {
  enrollments: PropTypes.arrayOf(enrollmentSummaryShape),
};

export default CohortEnrollmentsList;
